import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialSendMail: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M25.9 11.43H32v1.52h-6.1Zm3.05 3.05H32V16h-3.05ZM9.14 22.1h7.62v1.52h7.62v-3.05h4.57v-3.04h-1.52v1.52H1.52v-1.52H0v3.04h9.14zM24.38 16h3.05v1.53h-3.05Zm-1.53-7.62h3.05v1.53h-3.05Zm-1.52 6.1h3.05V16h-3.05Zm-3.05-1.53h-1.52v1.53h4.57v-1.53h-1.52v-1.52h-1.53zm1.53-1.52h1.52V8.38h-4.57v1.53h3.05z\"/><path fill=\"currentColor\" d=\"M13.71 9.91h3.05v1.52h-3.05Zm-1.52 4.57h4.57V16h-4.57Zm-1.53-3.05h3.05v1.52h-3.05Zm-3.04 1.52h3.04v1.53H7.62Zm-3.05 1.53h3.05V16H4.57ZM1.52 16h3.05v1.53H1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialSendMail
